import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import { useReports } from '@/pages/organizations/detail/reports'
import OrganizationModulePage from '@/features/reports/components/pages/OrganizationModulePage'

export const Route = createFileRoute(
  '/app/organizations/$organizationId/reports/modules/$moduleId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { moduleId } = Route.useParams()
  const { organization } = useOrganization()
  const { userCanViewAssessments } = useReports()

  return (
    <OrganizationModulePage
      organization={organization}
      moduleId={Number(moduleId)}
      userCanViewAssessments={userCanViewAssessments}
    />
  )
}
